module.exports = __webpack_public_path__ + "img/AE.978a5276.svg";